<template>
  <div class="container">
    <div class="ui grid stackable">
      <div class="twelve wide column">
        <h1>Wear Parts Listing</h1>
      </div>

      <listing-buttons :name="btnName" :route="route"></listing-buttons>
    </div>

    <div class="ui divider"></div>

    <div id="table">
      <div class="filter-bar ui grid">
        <div class="ui equal width stackable grid form px-0">
          <div
            class="column"
            v-for="(field, index) in searchFields"
            :key="field.key"
            :class="{ 'pl-0': index === 0 }"
          >
            <div class="ui input">
              <input
                type="text"
                v-model="search.fields[field.key]"
                @keyup.enter="doFilter"
                :placeholder="field.name"
              />
            </div>
          </div>
          <div class="column">
            <div class="ui button" @click="doFilter">Search</div>
          </div>
          <div class="column align-middle">
            <div class="ui checkbox" style="top: 10px;">
              <input
                type="checkbox"
                name="inactive"
                v-model="search.inactive"
              />
              <label>Inactive</label>
            </div>
          </div>
        </div>
      </div>
      <vuetable
        ref="vuetable"
        :fields="fields"
        :api-url="apiUrl"
        :data="wears"
        pagination-path=""
        :per-page="10"
        :multi-sort="true"
        :sort-order="sortOrder"
        :append-params="moreParams"
        @vuetable:pagination-data="onPaginationData"
        :http-options="httpOptions"
      >
        <template slot="link" slot-scope="wear">
          <div class="nowrap">
            <a class="ui link" @click="goToPart(wear.rowData.part)">{{
              wear.rowData.part.code
            }}</a>
          </div>
        </template>
        <template slot="assembly" slot-scope="wear">
          <div class="assembly">
            {{ wear.rowData.assembly.parentAssembly.name }}
          </div>
          <div class="sub-assembly">- {{ wear.rowData.assembly.name }}</div>
        </template>
        <template slot="actions" slot-scope="wear">
          <div class="table-button-container">
            <button class="ui primary button" @click="goToWear(wear)">
              <i class="fa fa-edit"></i></button
            >&nbsp;&nbsp;
            <button class="ui button" @click="deleteModal(wear.rowData.id)">
              <i class="fa fa-remove"></i></button
            >&nbsp;&nbsp;
          </div>
        </template>
      </vuetable>

      <vuetable-pagination
        ref="pagination"
        @vuetable-pagination:change-page="onChangePage"
      ></vuetable-pagination>
    </div>

    <semantic-modal small flip :active.sync="showModal">
      <div class="ui header">
        Delete Wear Part<i class="close icon" @click="showModal = false"></i>
      </div>
      <div class="content">Are you sure you want to delete this assembly?</div>
      <div class="actions">
        <div class="ui black deny button" @click="showModal = false">Nope</div>
        <div class="ui positive right labeled icon button" @click="wearDelete">
          Yes
          <i class="checkmark icon"></i>
        </div>
      </div>
    </semantic-modal>
  </div>
</template>

<script>
import Vue from "vue";
import Vuetable from "vuetable-2/src/components/Vuetable";
import VuetablePagination from "vuetable-2/src/components/VuetablePagination";
import SemanticModal from "vue-ya-semantic-modal";
import APIService from "@/assets/js/APIService";
const apiService = new APIService();
import httpClient from "@/assets/js/HttpClient";

export default {
  name: "Wear",
  components: {
    Vuetable,
    VuetablePagination,
    SemanticModal: SemanticModal(),
  },
  data() {
    return {
      btnName: "Wear Part",
      route: "Wear Details",
      Name: "Wear",
      showModal: false,
      id: "",
      fields: [
        {
          name: "__slot:link",
          title: "Part Code",
          sortField: "code",
        },
        {
          name: "part.description",
          title: "Item",
        },
        {
          name: "company.code",
          title: "Company #",
          sortField: "company",
        },
        {
          name: "machine.description",
          title: "Machine",
        },
        {
          name: "serialNumber",
          title: "Serial #",
        },
        {
          name: "__slot:assembly",
          title: "Assembly/Sub Assembly",
        },
        // {
        //   name: "assembly.parentAssembly.name",
        //   title: "Assembly",
        // },
        // {
        //   name: "assembly.name",
        //   title: "Sub Assembly",
        // },

        "__slot:actions",
      ],
      sortOrder: [
        {
          field: "code",
          sortField: "code",
          direction: "asc",
        },
        {
          field: "company.code",
          sortField: "company",
          direction: "asc",
        },
      ],
      moreParams: {},
      machine: "",
      machines: [],
      machineId: "",
      assembly: "",
      assemblies: [],
      assemblyId: "",
      subAssembly: "",
      subAssemblies: [],
      subAssemblyId: "",
      company: "",
      companies: [],
      companyId: "",
      wears: [],
      wearId: "",
      wear: "",
      part: "",
      parts: [],
      partId: "",
      apiUrl: apiService.getWearUrl(),
      httpOptions: {
        headers: httpClient.defaults.headers,
      },
      search: {
        filterText: "",
        filters: "",
        fields: {},
        inactive: false,
      },
      searchFields: [
        {
          name: "Part",
          key: "partCode",
        },
        {
          name: "Part Name",
          key: "partName",
        },
        {
          name: "Company Id",
          key: "companyCode",
        },
        {
          name: "Machine Name",
          key: "machineName",
        },
        {
          name: "Serial Number",
          key: "serial",
        },
        {
          name: "Assembly Name",
          key: "assemblyName",
        },
        {
          name: "Machine Code",
          key: "machineCode",
        },
      ],
    };
  },
  mounted() {
    $(".ui.dropdown").dropdown({ fullTextSearch: true });
    this.$events.$on("filter-set", (eventData) => this.onFilterSet(eventData));
    this.$events.$on("filter-reset", () => this.onFilterReset());

    if (this.$route.query.search != null) {
      this.setSearchParams(this.$route.query.search);
    }
  },
  methods: {
    setSearchParams(filterText) {
      if (filterText) {
        const filters = String(filterText).split("|");
        const fields = {};
        filters.forEach((f) => {
          const [key, value] = f.split("-");
          fields[key] = value;
        });

        this.search = Object.assign({}, this.search, { fields });
      }
      this.search.filterText = filterText;
      this.doFilter();
    },
    deleteModal(id) {
      this.showModal = !this.showModal;
      this.wear = id;

      return id;
    },
    getWears() {
      apiService.getWears().then((data) => {
        this.wears = data;
      });
    },
    goToPart(part) {
      this.$router.push({
        name: "EditParts",
        params: {
          id: part.id,
        },
      });
    },
    goToWear(wear) {
      this.$router.push({
        name: "Wear Details",
        params: {
          id: wear.rowData.id,
        },
      });
    },
    wearDelete() {
      var wear = this.wear;

      apiService
        .deleteWear({ id: wear })
        .then((request) => {
          this.wearSuccessful(request);
          this.showModal = !this.showModal;
          location.reload();
        })
        .catch((err) => this.wearFailed(err));
    },
    wearSuccessful(request) {
      (this.machine = request.machine),
        (this.assembly = request.assembly),
        (this.subAssembly = request.subAssembly),
        (this.part = request.part),
        (this.machineCode = request.code),
        (this.machineDescription = request.description),
        (this.active = request.active);
    },
    wearFailed(err) {
      this.$bvToast.toast("TraceID: " + err.error.response.data.traceId, {
        title: err.error.response.data.title,
        autoHideDelay: 10000,
        appendToast: false,
        variant: "danger",
        solid: true,
      });
    },
    onPaginationData(paginationData) {
      this.$refs.pagination.setPaginationData(paginationData);
    },
    onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },
    doFilter() {
      const filterText = Object.keys(this.search.fields)
        .map((k) =>
          this.search.fields[k] ? `${k}-${this.search.fields[k]}` : ""
        )
        .join("|");
      if (this.search.filterText !== filterText) {
        this.search = Object.assign({}, this.search, { filterText });
      }
      this.$events.fire("filter-set", this.search);

      if (this.$route.query.search !== null) {
        this.$set(
          this.search,
          this.search.filterText,
          this.$route.query.search
        );
      } else {
        this.$router.push({
          path: "wear",
          query: { search: this.search.filterText },
        });
      }

      if (this.$route.query.search != this.search.filterText) {
        delete this.$route.query.search;
        this.$router.push({
          path: "wear",
          query: { search: this.search.filterText },
        });
      }
    },
    onFilterSet(data) {
      this.moreParams.filter = data.filterText;
      this.moreParams.inactive = data.inactive || this.active;
      Vue.nextTick(() => {
        this.$refs.vuetable?.refresh();
      });
    },
    onFilterReset() {
      delete this.moreParams.filter;
      Vue.nextTick(() => this.$refs.vuetable.refresh());
    },
  },
  destroyed: function() {
    this.$events.off("filter-set");
    this.$events.off("filter-reset");
  },
};
</script>
